import { IProduct } from '@cemex-core/cmx-api/models/product/models/product.interface';
import { ProductsActions, ProductsActionTypes } from '../actions/products.actions';
import { uniqueByKeys } from '../../../../shared/utils/unique-by-keys';
import { RESET_BUILDER, OrderBuilderActions } from '../../../actions/order-builder.actions';
import { ProductOP } from '@cemex-core/cmx-api';

/**
 * The store's array of products available to the customer. (Probably in the context of a given jobsite, but this is
 * not explicitly stated.)
 */
export interface ProductsState {
  loading: boolean;
  availableProducts: IProduct[];
  availableProductsULink: ProductOP[];
}

/**
 * The initial state of the product-list:  Not loading and empty.
 * @type {{availableProducts: any[]; loading: boolean}}
 */
export const initialState: ProductsState = {
  loading: false,
  availableProducts: [],
  availableProductsULink: [],
};

/**
 * When the SAP code isn't unique for some reason, the commercial description is added to make a unique product key.
 * @type {string[]}
 */
export const uniqueProductKeys = ['commercialCode', 'commercialDesc'];
export const uniqueProductULinkKeys = ['productCode', 'productDesc'];

/**
 * Returns the list of products with only the first item of any products with the same unique product key.
 * @param products
 * @return {any[]}
 */
export function filterUniqueProducts(products) {
  return uniqueByKeys(products, uniqueProductKeys);
}
/**
 * Uses concat for filtering both arrays of keys in case the feature toggle is off, for compatibility
 * @param products
 * @returns
 */
export function filterUniqueULinkProducts(products) {
  return uniqueByKeys(products, uniqueProductULinkKeys.concat(uniqueProductKeys));
}

/**
 * Updates the state of the product-list in the specification step of the one-click order workflow.
 * @param {ProductsState} state
 * @param {ProductsActions | OrderBuilderActions} action
 * @return {ProductsState}
 */
export function productsReducer(state = initialState, action: ProductsActions | OrderBuilderActions): ProductsState {
  switch (action.type) {
    case ProductsActionTypes.LOAD: {
      return {
        ...state,
        loading: true,
      } as ProductsState;
    }
    case ProductsActionTypes.LOAD_COMPLETE: {
      return {
        ...state,
        loading: false,
        availableProducts: filterUniqueProducts([...action.payload]),
      } as ProductsState;
    }
    case ProductsActionTypes.LOAD_ULINK_COMPLETE: {
      return {
        ...state,
        loading: false,
        availableProductsULink: action.payload.products,
      } as ProductsState;
    }
    case ProductsActionTypes.ADD_PRODUCTS: {
      return {
        ...state,
        availableProducts: [...state.availableProducts, ...action.payload],
      } as ProductsState;
    }
    case ProductsActionTypes.ADD_PRODUCTS_ULINK: {
      return {
        ...state,
        availableProductsULink: filterUniqueULinkProducts([...state.availableProductsULink, ...action.payload]),
      } as ProductsState;
    }
    case RESET_BUILDER:
    case ProductsActionTypes.RESET: {
      return {
        ...initialState,
      };
    }
    default: {
      return state;
    }
  }
}
